//types
import { RootState } from "../../../../types/store";
//import redux
import { connect } from "react-redux";

// actions
import { getOrdersRequest } from "../../../../redux/actions/dashboard/orders.actions";

// types
// import {Order} from "../../../../types/orders/order";
import {DateRange} from "../../../../types/common";

// component
import OrdersComponent from "./Orders.component";
import {getCurrentTab} from "../../../../utils/functions";

interface ownProps {
  // orders: Order[];
  // fetchingOrders: boolean;
  // filters
  rangeDate: DateRange;
  activeFilters: any;
  sendFilters: () => void;
  // take: number;
  // skip: number;
  // total: number;
}

const mapStateToProps = function (state: RootState, ownProps: ownProps) {
  return {
    orders: state.orders.orders,
    total: state.orders.total,
    skip: state.orders.skip,
    take: state.orders.take,
    fetchingOrders: Boolean(
      state.orders.fetchingOrders > 0
    ),
  };
};

const mapDispatchToProps = function (dispatch: any) {
  return {
    getOrdersRequest: (data: any, params: any) =>
      dispatch(getOrdersRequest(data, params, getCurrentTab())),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(OrdersComponent);
